module.exports = __webpack_public_path__ + "img/scaleExplain.6a8ec4a0.png";